import React, { memo, useCallback } from "react";
import ScrollToTop from "./common/ScrollToTop";
import { FiChevronUp } from "react-icons/fi";
import { isMobileOnly } from "react-device-detect";
import {
  SponsorEntity,
  BackgroundImageEntity,
  DocumentEntity,
  VideoEntity,
} from "../types/strapi";
import { imgSize } from "../utils/funcs";
import PageHelmet from "./common/Helmet";
import Header from "./common/Header";
import Breadcrumb from "./common/Breadcrumb";
import Image from "./objects/Image";
import BrandTwo from "./BrandTwo";
import FooterTwo from "./common/FooterTwo";
import TabThree from "./tab/TabThree";

interface ArchiveProps {
  backgroundImages?: BackgroundImageEntity[];
  documents?: DocumentEntity[];
  sponsors: SponsorEntity;
  videos?: VideoEntity[];
}

const Archive: React.FC<ArchiveProps> = ({
  backgroundImages = [],
  documents = [],
  sponsors,
  videos = [],
}) => {
  const section = "Archive";

  const findBackgroundImage = useCallback(
    () =>
      backgroundImages.find(
        (item) =>
          item.section?.toLowerCase() === section.toLowerCase()
      ) ?? null,
    [backgroundImages, section]
  );

  const renderTabThree = useCallback(
    () => (
      <div className="designer-portfolio-area ptb--120 bg_color--1">
        <div className="wrapper plr--70 plr_sm--30 plr_md--30">
          <TabThree
            column="col-lg-4 col-md-6 col-sm-6 col-12 "
            documents={documents}
            videos={videos}
          />
        </div>
      </div>
    ),
    [documents, videos]
  );

  const renderBackgroundImage = useCallback(() => {
    const backgroundImage = findBackgroundImage();
    const imgAttributes = backgroundImage?.image;

    if (!imgAttributes || backgroundImages.length === 0) {
      return null;
    }

    return (
      <Image
        caption={imgAttributes.caption ?? ""}
        cssClass="mb-dec--40"
        type="fullWidth"
        imgUrl={imgSize(imgAttributes, isMobileOnly)}
      />
    );
  }, [backgroundImages, findBackgroundImage]);

  return (
    <>
      <PageHelmet pageTitle={section} />
      <Header />

      <Breadcrumb backgroundSection={section} title="Archive" />

      {renderTabThree()}
      {renderBackgroundImage()}

      <BrandTwo sponsors={sponsors} />

      <div className="backto-top">
        <ScrollToTop showUnder={160}>
          <FiChevronUp />
        </ScrollToTop>
      </div>

      <FooterTwo />
    </>
  );
};

export default memo(Archive);
